import Vue from "vue";
import App from "./App.vue";
import VueRouter from 'vue-router'
import Portfolio from './Portfolio.vue'
import MountPoint from './MountPoint.vue'
import Gandalf from './Ganjalf.vue'
Vue.config.productionTip = false;
Vue.use(VueRouter)
const routes = [
  { path: '/', component: App },
  { path: '/portfolio', component: Portfolio },
  { path : '/gandalf', component : Gandalf }
]
const router = new VueRouter({
  mode : 'hash', 
  routes
})
new Vue({
  router,
  render: h => h(MountPoint)
}).$mount("#app");
